import '../css/landing.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from 'react-router-dom';

export default function Landing() {
    const navigate = useNavigate();
    return(
        <div className="landing bg-blue-100">
            <div className="mission">
                <h2 className="mission-title">ማህበሩ የተቋቋመበት አላማ</h2>
                <p className="mission-description">
                <ol className="list-group list-group-numbered custom-list">
                <li className="list-group-item text-justify bg-blue-100">በየወሩ በ30ኛው ቀን የመጥምቀ መለኮትን ዝክር መዘከር ገድሉን ማንበብና ቃለ ወንጌል መማር  እንዲሁም ምዕመናንም ይህንን እንደዚሁ እንዲያደርጉ ማስተማር፡፡</li>                     
                <li className="list-group-item text-justify">ምዕመናን በቤተክርስቲያን እንቅስቃሴ ውስጥ በቀጥታ ተሳታፊ እንዲሆንና ከቤተክርስቲያን የተጣለባቸውን ኃላፊነት በብቃት እንዲወጡ በቃለ ወንጌልና በቤተክርስቲያን ሥርዓት ትምህርት ማነጽ፡፡</li>
                <li className="list-group-item text-justify">ምዕመናንን በማስተባበር በማረሚያ ቤቶች፣ ያሉ የህግ ታራሚዎች በሆስፒታሎች ያሉ ህሙማን እንዲሁም በፀበል ቦታዎች ያሉ ህሙማንንና ነዲያንንመጎብኘትና መርዳት፡፡</li> 
                <li className="list-group-item text-justify">በተናጠልም ሆነ ከተመሳሳይ ማህበራት ጋር በአንድነት ቋሚ የገንዘብ ምንጭ የሌላቸውን አድባራትና ገዳማትን ቋሚና ጊዜያዊ ፕሮጀክቶችን በማዘጋጀት መርዳት፡፡</li>
                <li className="list-group-item text-justify">ጧሪ ቀባሪ የሌላቸውን የተቸገሩ አረጋውያንን ፣ወላጅ አልባ ህፃናትንና የሚረዳቸው የሌላቸው አካለ ጉዳተኞችን መርዳት፡፡</li>
                <li className="list-group-item text-justify">በተለያዩ መንፈሳዊ ጉዞዎችን በማዘጋጀት ምዕመናን ከቅዱሳን መካናት በረከትና ረድኤትን እንዲያገኙ ማስቻል፡፡</li>
                <li className="list-group-item text-justify">በማህበርተኛው ደስታ ላይ በመገኘት የደስታው ተካፋይ መሆን ፣ ሀዘን በደረሰ ጊዜ ማፅናናት ፣ በህመሙ ጊዜም መጠየቅ እንዲሁም አስታማሚ የሌላቸውን ማህበርተኞች ማስታመምና መርዳት፡፡</li> 
                <li className="list-group-item text-justify">ወጣቱ ከአጉል ሱሶች እንዲርቅና በቤተክርስቲያን አገልግሎት ተሳታፊ እዲሆን በክርስቲያናዊ ስነ-ምግባር ማነፅ፡፡</li>
                <li className="list-group-item text-justify">ለማህበርተኛም ይሁን የማህበሩን መስፈርት ለሚያሟሉ ምዕመናን የሰርግ መዝሙር አገልግሎት መስጠት፡፡</li> 
                <li className="list-group-item text-justify">ለቤተክርስቲያን ወቅታዊ ጥሪ አፍጣኝ ምላሽ መስጠት እና ሌሎች ተመሳሳይ መንፈሳዊ አገልግሎቶችን ማከናወን ናቸው፡፡ </li>
                </ol>
                </p>
            </div>
        </div>
    );
}
